import uploadService from 'utils/images/uploadPhoto';

const getRemoveBGSrcUrl = async (removeBgSrc: string) => {
  const blobSrc = typeof removeBgSrc === 'string' ? removeBgSrc : null;
  const loadedBlobImage = blobSrc && removeBgSrc?.startsWith('blob') ? await fetch(blobSrc) : null;
  const resultBlob = loadedBlobImage ? await loadedBlobImage.blob() : null;
  const resultSrc = resultBlob ? await uploadService.upload(resultBlob) : null;

  return resultSrc || removeBgSrc;
};

export default getRemoveBGSrcUrl;
